import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decisionApi, type Optimization } from '../../api/decision';

export function OptimizationCenterPage() {
  const [opts, setOpts] = useState<Optimization[]>([]);

  useEffect(() => {
    void decisionApi.listOptimizations((getWorkspaceId() ?? '')).then(setOpts);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Optimization Center</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Inventory, pricing, advertising, logistics and profitability optimization engines.</p>
      <Link to="/decision" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← Decision Center</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {opts.map((o) => (
          <div key={o.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <div className="flex justify-between">
              <span className="font-medium">{o.title}</span>
              <span className="text-sm text-green-600">+{o.improvement_pct.toFixed(1)}%</span>
            </div>
            <p className="mt-1 text-xs text-slate-500 capitalize">{o.domain.replace(/_/g, ' ')} · {o.status}</p>
            <p className="mt-2 text-sm text-slate-500">Confidence: {(o.confidence * 100).toFixed(0)}%</p>
          </div>
        ))}
      </div>
    </div>
  );
}
